import React, { useState } from 'react';
import { createPortal } from 'react-dom';
import { Col, Row } from 'antd';
import { useDispatch } from 'react-redux';
import { Link, useParams, useHistory } from 'react-router-dom';
import Box from '@iso/components/utility/box';
import Button from '@iso/components/uielements/button';
import notification from '@iso/components/Notification';
import paymentFormActions from '@iso/redux/paymentForm/actions';
import ContentHolder from '@iso/components/utility/contentHolder';
import LayoutWrapper from '@iso/components/utility/layoutWrapper';
import Input, { InputGroup } from '@iso/components/uielements/input';
import Select, { SelectOption } from '@iso/components/uielements/select';
import Loader from '@iso/components/utility/loader';
import PageTitleBar from '@iso/components/utility/PageTitleBar';
import PageWrapper, { Fieldset, Label } from './Single.styles';

import apiPaymentForm from '@iso/services/repository/comercialCondition/paymentForm';

const { updatePaymentForm } = paymentFormActions

const Option = SelectOption;

export default function EditForm({ paymentFormId: idProp, onSaved, onCancel, inModal = false, footerEl = null } = {}) {
  const params = useParams();
  const paymentFormId = idProp !== undefined ? idProp : params.paymentFormId;
  const [load, setLoad] = useState(true);
  const [paymentForm, setPaymentForm] = useState({situation: 'Ativo'});
  const dispatch = useDispatch();
  let history = useHistory();
  
  React.useEffect(() => {
    apiPaymentForm
      .getPaymentFormById(paymentFormId)
      .then((response) => {
        if(!response.data.error){
          setPaymentForm(response.data)
        } else {
          setPaymentForm(prevState => {
            return { ...prevState, situation: 'Ativo'}
          })
        }
        setLoad(false);
      })
      .catch((err) => {
        console.error("ops! ocorreu um erro" + err);
      });
  }, [paymentFormId]);

  function checkValues(){
    if(!paymentForm.name){
      notification('error', 'Preencha o nome')
      return false;
    }
    if(!paymentForm.situation){
      setPaymentForm(prevState => {
        return { ...prevState, situation: 'Ativo' }
      });
    }

    return true;
  }

  // Função do botão Salvar
  const handleSubmit = () => {
    const continuar = checkValues(paymentForm);
    if(continuar === true){
      ( !(paymentForm.error) && typeof paymentForm._id !== "undefined" && paymentForm._id !== null ) ?
        notification('success', 'Forma de Pagamento Salvo') :
        notification('success', 'Forma de Pagamento Criado');
        
      dispatch(updatePaymentForm(paymentForm));
      if (onSaved) onSaved(); else history.push('/dashboard/payment-form');
    }
  }

    const actionButtons = (
    <>
{inModal ? (
          <Button color="primary" onClick={onCancel}>
            <span>Cancelar</span>
          </Button>
        ) : (
          <Link to="/dashboard/payment-form">
          <Button color="primary">
            <span>Cancelar</span>
          </Button>
        </Link>
        )}
        <Button type="primary" onClick={handleSubmit} className="saveBtn">
          <span>Salvar</span>
        </Button>
    </>
  );
  const actionsRender = footerEl ? (
    createPortal(actionButtons, footerEl)
  ) : (
    <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8, padding: '10px 4px 20px' }}>
      {actionButtons}
    </div>
  );
return (load) ? <Loader /> : (
    <LayoutWrapper>
      {inModal ? null : (
        <PageTitleBar title={`${paymentForm._id ? 'Editar' : 'Cadastrar'} Forma de Pagamento`} backTo="/dashboard/payment-form" />
      )}
      {actionsRender}
      <Box style={{ border: 'none', boxShadow: 'none' }}>
        <PageWrapper className="editView">
          <div className="PageContent">
            <Box className="productTabsBox" style={{ border: 'none', boxShadow: 'none', padding: 0, background: 'transparent' }} title={<div id="forms.PaymentForm.verticalTitle" />}>
              <ContentHolder>
                <InputGroup size="large" style={{ marginBottom: '15px' }}>
                  <Row gutter={24}>
                    <Col span={12}>
                      <Fieldset>
                        <Label>Nome*</Label>
                        <Input
                          placeholder="Nome"
                          value={paymentForm.name}
                          name="name"
                          onChange={(e) => {setPaymentForm(prevState => {
                              return { ...prevState, name: e.target.value }
                            });
                          }}
                          className="BillFormTitle"
                          />
                      </Fieldset>
                    </Col>
                    <Col span={6}>
                      <Fieldset>
                        <Label>Tipo de Pagamento*</Label>
                        <Select
                          value={(typeof(paymentForm?.real_form) !== 'undefined') ? paymentForm?.real_form : ''}
                          onChange={(e) => {setPaymentForm(prevState => {
                              return { ...prevState, real_form: e }
                            });
                          }}
                          >
                          <Option key={'null'} value={''}>---</Option>
                          <Option key={'BOLETO'} value={'BOLETO'}>Boleto</Option>
                          <Option key={'DEBIT_CARD'} value={'DEBIT_CARD'}>Cartão de débito</Option>
                          <Option key={'CREDIT_CARD'} value={'CREDIT_CARD'}>Cartão de crédito</Option>
                          <Option key={'CHEQUE'} value={'CHEQUE'}>Cheque</Option>
                          <Option key={'MONEY'} value={'MONEY'}>Dinheiro</Option>
                          <Option key={'PIX'} value={'PIX'}>PIX</Option>
                        </Select>
                      </Fieldset>
                    </Col>
                    <Col span={6}>
                      <Fieldset>
                        <Label>Situação*</Label>
                        <Select
                          value={(typeof(paymentForm?.situation) !== 'undefined') ? paymentForm?.situation : 'Ativo'}
                          onChange={(e) => {setPaymentForm(prevState => {
                              return { ...prevState, situation: e }
                            });
                          }}
                          >
                          <Option key="Ativo" value="Ativo">Ativo</Option>
                          <Option key="Inativo" value="Inativo">Inativo</Option>
                        </Select>
                      </Fieldset>
                    </Col>
                  </Row>
                </InputGroup>
              </ContentHolder>
            </Box>
          </div>
        </PageWrapper>
      </Box>
    </LayoutWrapper>
  );
}
